import { useRef } from 'react';
import { AccordionSummary as MuiAccordionSummary } from '@mui/material';
import { Box } from '../../Box';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import accordionSummaryStyleBuilder, { imageBuilder, containereBuilder } from './accordionSummaryStyleBuilder';
import { ChevronRightIcon, ChevronDownIcon } from '../../Icons';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/** Component that has the accordion title  */
export const AccordionSummary = props => {
  const {
    badge,
    children,
    contained = false,
    icon,
    chevronPosition,
    sx,
    id,
    className,
    ...rest
  } = props;
  const ref = useRef(null);
  const boxRef = useRef(null);
  const theme = useInterstateTheme();
  const style = mergeSxStyle(accordionSummaryStyleBuilder(theme, chevronPosition, contained), sx);
  const menuImageStyle = imageBuilder(theme);
  const containerStyle = containereBuilder(theme);
  const handleKeyUp = e => {
    if (e?.key === 'Enter') {
      ref.current?.click();
    }
  };
  const _expandIcon = chevronPosition === 'left' ? /*#__PURE__*/_jsx(ChevronRightIcon, {
    color: theme.tokens.ComponentAccordionSummaryIconColor
  }) : /*#__PURE__*/_jsx(ChevronDownIcon, {
    color: theme.tokens.ComponentAccordionSummaryIconColor
  });
  return /*#__PURE__*/_jsxs(Box, {
    id: id,
    "data-testid": rest['data-testid'],
    sx: containerStyle,
    tabIndex: 0,
    onKeyUp: e => handleKeyUp(e),
    ref: boxRef,
    className: className,
    children: [/*#__PURE__*/_jsxs(MuiAccordionSummary, {
      expandIcon: _expandIcon,
      sx: style,
      tabIndex: -1,
      ref: ref,
      children: [icon !== undefined && /*#__PURE__*/_jsx(Box, {
        sx: menuImageStyle,
        children: chevronPosition === 'left' ? null : icon
      }), children]
    }), badge ? /*#__PURE__*/_jsx(Box, {
      sx: {
        margin: '8px 4px'
      },
      children: badge
    }) : null]
  });
};